export class StringFormatter {
  public zero = 0;
  public one = 1;
  public two = 2;
  public three = 3;
  public four = 4;

  public formatCadastreKey(key: string): string {
    const components = key.split('-');
    let formattedCadastreKey = components[this.zero] + '/' + components[this.one] + '/' + components[this.two];
    if (components[this.four] !== '0') {
      formattedCadastreKey += '/' + components[this.three] + '/' + components[this.four];
    } else if (components[this.three] !== '0') {
      formattedCadastreKey += '/' + components[this.three];
    }
    return formattedCadastreKey;
  }

  public formatMonetaryAmount(amount: string): string {
    let remainingComponents = amount.length / this.three +
      (amount.length % this.three > this.zero ? this.one : this.zero);
    let formattedAmount = '';
    let i = amount.length - this.three;
    let j = amount.length;
    while (remainingComponents >= this.zero) {
      formattedAmount = i > this.zero
        ? '.' + amount.substring(i, j) + formattedAmount
        : amount.substring(i, j) + formattedAmount;
      j = i;
      i = i - this.three < this.zero ? this.zero : i - this.three;
      remainingComponents--;
    }
    return formattedAmount;
  }
}
export default new StringFormatter();



/** WEBPACK FOOTER **
 ** ./src/utility/StringFormatter.ts
 **/